import { createHook, createStore } from 'react-sweet-state'
import { apiCall } from '../core/store'

// This is the value of the store on initialisation
const initialState = {
  endpoint: '/categories',
  filters: {},
  all: []
}

// All the actions that mutate the store
const actions = {
  fetch: (filters) => async ({ setState, dispatch }) => {
    const res = await dispatch(apiCall({ params: filters }))
    res && res.result && setState({ all: res.result })
  },
  setFilter: ({ key, value }) => async ({ setState, getState, dispatch }) => {
    setState({
      filters: {
        ...getState().filters,
        [key]: value
      }
    })
    dispatch(actions.fetch(getState().filters))
  }
}

const Store = createStore({ initialState, actions, name: 'categories' })

export const useCategoriesRequest = createHook(Store, {
  selector: (state, props) => state.requests && state.requests[props.key]
})

export const useCategoriesForFilters = createHook(Store, {
  selector: (state, props = {}) => {
    const sanitize = (categories) => categories.map((category) => ({
      value: category._id,
      label: category.labels[props.language || 'fr'],
      childrens: category.childrens && sanitize(category.childrens)
    }))

    return sanitize(state.all)
  }
})

export const useCategories = createHook(Store)
